import React, { useEffect, useState } from 'react';
import { Users } from 'lucide-react';
import { motion } from 'framer-motion';
export function LiveVisitors() {
  const [count, setCount] = useState(87);
  useEffect(() => {
    // Randomly fluctuate the number every 5 seconds
    const interval = setInterval(() => {
      setCount(prev => {
        const change = Math.floor(Math.random() * 5) - 2; // -2 to +2
        const newCount = prev + change;
        return newCount < 47 ? 47 : newCount > 189 ? 189 : newCount;
      });
    }, 5000);
    return () => clearInterval(interval);
  }, []);
  return <div className="bg-[#2F855A] text-white py-2 px-4 text-center text-sm font-medium flex justify-center items-center gap-2 shadow-sm relative z-50" data-id="element-118">
      <span className="relative flex h-3 w-3" data-id="element-119">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75" data-id="element-120"></span>
        <span className="relative inline-flex rounded-full h-3 w-3 bg-green-300" data-id="element-121"></span>
      </span>
      <span data-id="element-122">{count} personas viendo esta página ahora</span>
    </div>;
}